export default __webpack_public_path__ + "static/media/Fav Icon.abc0ae21.png";